import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Copy } from "@phosphor-icons/react/dist/ssr/Copy";
import { TrashSimple as TrashIcon } from "@phosphor-icons/react/dist/ssr/TrashSimple";

export interface ItemMenuProps {
	anchorEl?: HTMLElement | null;
	onClose?: () => void;
	onDelete?: () => void;
	onDuplicate?: () => void;
	open?: boolean;
}

export function ItemMenu({
	anchorEl,
	onClose,
	onDelete,
	onDuplicate,
	open = false,
}: ItemMenuProps) {
	return (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
			onClose={onClose}
			open={open}
			transformOrigin={{ horizontal: "right", vertical: "top" }}>
			<MenuItem onClick={onDuplicate}>
				<ListItemIcon>
					<Copy />
				</ListItemIcon>
				Duplicate
			</MenuItem>
			<MenuItem
				onClick={onDelete}
				sx={{ color: "var(--mui-palette-error-main)" }}>
				<ListItemIcon>
					<TrashIcon />
				</ListItemIcon>
				Delete map
			</MenuItem>
		</Menu>
	);
}
